import {
  B200,
  B300,
  G200,
  G300,
  P200,
  P300,
  R200,
  R300,
  T75,
  T100,
  T200,
  T300,
  Y200,
  Y300,
} from '@atlaskit/theme/colors';
import { ImmutableUtils } from '@atlassian/mpac-utils';
import { List } from 'immutable';

import RotatableEntity from '../../../../../../../../common/records/RotatableEntity';
import CategoryTile from '../records/CategoryTile';
import CategoryTileSet from '../records/CategoryTileSet';

import ArtificialIntelligence from '../../../../config/images/artificial-intelligence.svg';
import Changemakers from '../../../../config/images/changemakers-for-old-collections.svg';
import ChartsAndDiagrams from '../../../../config/images/charts-diagrams.svg';
import CustomerSupport from '../../../../config/images/customer-support.svg';
import DesignTools from '../../../../config/images/design-tools.svg';
import DocumentManagement from '../../../../config/images/DocumentManagement.svg';
import ITSM from '../../../../config/images/ITSM.svg';
import Monitoring from '../../../../config/images/Monitoring.svg';
import ProjectManagement from '../../../../config/images/project-management.svg';
import TestManagement from '../../../../config/images/test-management.svg';
import ThemesStyles from '../../../../config/images/themes-and-styles.svg';
import TimeTracking from '../../../../config/images/time-tracking.svg';

const chartsDiagrams = new CategoryTile({
  key: 'charts-diagrams',
  name: 'Charts and diagrams',
  image: ChartsAndDiagrams,
  backgroundColor: R200,
  hoverBackgroundColor: R300,
});

const designTools = new CategoryTile({
  key: 'design-tools',
  name: 'Design tools',
  image: DesignTools,
  backgroundColor: G200,
  hoverBackgroundColor: G300,
});

const themesStyles = new CategoryTile({
  key: 'themes-styles',
  name: 'Themes and styles',
  image: ThemesStyles,
  backgroundColor: T200,
  hoverBackgroundColor: T300,
});

const testManagement = new CategoryTile({
  key: 'test-management',
  name: 'Test management',
  image: TestManagement,
  backgroundColor: P200,
  hoverBackgroundColor: P300,
});

const timeTracking = new CategoryTile({
  key: 'time-tracking',
  name: 'Time tracking',
  image: TimeTracking,
  backgroundColor: Y200,
  hoverBackgroundColor: Y300,
});

const projectManagement = new CategoryTile({
  key: 'project-management',
  name: 'Project management',
  image: ProjectManagement,
  backgroundColor: B200,
  hoverBackgroundColor: B300,
});

const documentManagement = new CategoryTile({
  key: 'document-management',
  name: 'Document management',
  image: DocumentManagement,
  backgroundColor: T200,
  hoverBackgroundColor: T300,
});

const itsm = new CategoryTile({
  key: 'it-service-management',
  name: 'IT service management',
  image: ITSM,
  backgroundColor: P200,
  hoverBackgroundColor: P300,
});

const monitoring = new CategoryTile({
  key: 'monitoring',
  name: 'Monitoring',
  image: Monitoring,
  backgroundColor: T75,
  hoverBackgroundColor: T100,
});

const customerSupport = new CategoryTile({
  key: 'customer-support',
  name: 'Customer support',
  image: CustomerSupport,
  backgroundColor: T200,
  hoverBackgroundColor: T300,
});

const artificialIntelligence = new CategoryTile({
  key: 'artificial-intelligence',
  name: 'Artificial intelligence',
  image: ArtificialIntelligence,
  backgroundColor: T200,
  hoverBackgroundColor: T300,
});

const changemakers = new CategoryTile({
  key: 'changemakers',
  name: 'Changemakers',
  image: Changemakers,
  backgroundColor: T200,
  hoverBackgroundColor: T300,
});

const getFeaturedCategories = (featureFlags) => {
  const { showChangemakersCollectionTileFlag } = featureFlags;
  const jsmJsdLabel = 'Jira Service Management';

  const discoverNewApps = [
    chartsDiagrams,
    designTools,
    testManagement,
    timeTracking,
    projectManagement,
    artificialIntelligence,
  ];

  if (showChangemakersCollectionTileFlag) {
    discoverNewApps.push(changemakers);
  }

  return ImmutableUtils.listToMap(
    List([
      new CategoryTileSet({
        key: 'home',
        heading: 'Discover new apps',
        tagline:
          'Browse through our category pages to learn about new useful apps you may have never heard of before.',
        categoryTiles: new RotatableEntity({
          unpinned: List(discoverNewApps),
        }),
      }),
      new CategoryTileSet({
        key: 'jira',
        heading: 'Top Jira categories',
        tagline:
          'Apps transform Jira into a tightly integrated product development solution for teams who need to get more done in less time.',
        categoryTiles: new RotatableEntity({
          unpinned: List([
            designTools,
            testManagement,
            timeTracking,
            projectManagement,
            itsm,
            monitoring,
          ]),
        }),
      }),
      new CategoryTileSet({
        key: 'jsd',
        heading: `Top ${jsmJsdLabel} categories`,
        tagline: `Supercharge your ${jsmJsdLabel} with your favorite IT and customer support apps and bring an open, simple and human approach to service.`,
        categoryTiles: new RotatableEntity({
          unpinned: List([itsm, customerSupport, monitoring]),
        }),
      }),
      new CategoryTileSet({
        key: 'confluence',
        heading: 'Top Confluence categories',
        tagline:
          'Confluence is an open and shared workspace that helps teams do their best work. It can be customized \
                          to fit any department or project. Bring everyone together in one place with Confluence.',
        categoryTiles: new RotatableEntity({
          unpinned: List([chartsDiagrams, designTools, documentManagement, themesStyles]),
        }),
      }),
    ]),
    (fc: any) => fc.key
  );
};

export default getFeaturedCategories;
